<template lang="pug">
  div
    div(v-for='child in children')
      transform(:transform='child',
        :parent-container='parentContainer',
        :partutil='partutil',
        :key='child.id',
        :depth='depth+1',
        :parent-transform='parentTransform',
        :context='context',
        @loaded='doneLoading',
        :render-tools='renderTools')
        template(#holder="{parentTransform,...rest}")
          slot(name='child'
            v-bind:parentTransform='rest.parentTransform || parentTransform',
            v-bind:childComponent='rest.childComponent || childComponent'
            v-bind='rest'
          )

</template>
<script>
import DefaultOverlay from '@ui/molecules/DefaultOverlay.vue';
export default {
  props:{
    children:{
      type:Array,
      required:true
    },
    parentContainer:{
      type:Object,
      required:true
    },
    childComponent: {
      type:Object,
      default() {
        return DefaultOverlay
      }
    },
    depth:{
      type:Number,
      default:0
    },
    parentTransform:{
      type:Object,
      required:true
    },
    partutil:{
      type:Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    },
    context:{
      type:Object,
      default() {
        return {};
      }
    }
  },
  components:{
    Transform: () => import('./Transform.vue'),
  },
  data() {
    const total = this.children.length;
    const loaded = 0;
    return {
      loaded,
      total
    }
  },
  methods:{
    doneLoading() {
      this.loaded++;
      if (this.total === this.loaded) {
        this.$emit("loaded");
      }
    }
  }
}
</script>
